import React from 'react';

/**
 * 마스커레이드(스텝→사장) 로그인 배너 (114). 스텝이 자기 구글로 로그인했지만 실제로는
 * 사장 사업장 계정으로 들어와 있음을 명시 — 개인 계정으로 오인해 개인 콘텐츠를 올리지
 * 않게. sudo 배너와 달리 "종료" 버튼이 없다(스텝은 이 계정이 자기 작업 계정이므로).
 */
const MasqueradeBanner: React.FC<{ accountName: string | null }> = ({ accountName }) => (
  <div className="bg-indigo-600 text-white text-sm px-4 py-2 flex items-center justify-center gap-2">
    <span aria-hidden>🏢</span>
    <span>
      <b>{accountName || '사업장'}</b> 계정으로 로그인되어 있습니다 — 여기 올리는 영상·설정은 이 사업장에 반영됩니다.
    </span>
  </div>
);

export default MasqueradeBanner;
